@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  p {
    border: none; /* reset browser default borders */
    font-style: normal;

    &[disabled] {
      cursor: not-allowed;
    }

    /* SIZE */
    &.s {
      font: var(--semantic-text-body-s);
      letter-spacing: var(--semantic-letter-spacing-body-s);
    }

    &.m {
      font: var(--semantic-text-body-m);
      letter-spacing: var(--semantic-letter-spacing-body-m);
    }

    &.l {
      font: var(--semantic-text-body-l);
      letter-spacing: var(--semantic-letter-spacing-body-l);
    }

    /* VARIANT */
    &.primary {
      color: var(--semantic-color-on-surface-primary-resting);

      /* INVERSE (Negative Region / Context Based) */
      &.inverse {
        color: var(--semantic-color-on-surface-primary-inverse-resting);
      }
    }

    &.secondary {
      color: var(--semantic-color-on-surface-secondary-resting);

      /* INVERSE (Negative Region / Context Based) */
      &.inverse {
        color: var(--semantic-color-on-surface-secondary-inverse-resting);
      }
    }

    /* FOCUS STATES */
    &:focus {
      outline: var(--semantic-border-width-focus) solid var(--semantic-color-border-focus);
      outline-offset: var(--semantic-spacing-focus-offset);
    }
  }
}
